import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { screeningRoutePaths } from './models/path-model';

const ScreeningStoriesListPage = React.lazy(
  () => import('./pages/screening-stories-list-page'),
);
const ScreeningStoryResumePage = React.lazy(
  () => import('./pages/screening-story-resume-page'),
);

export const screeningRoutes: Sebrae.RoutesConfig = [
  {
    routePath: screeningRoutePaths.home,
    pageToRender: <ScreeningStoriesListPage />,
    ifIsAuthenticated: true,
  },
  {
    routePath: screeningRoutePaths.storiesList,
    pageToRender: <ScreeningStoriesListPage />,
    ifIsAuthenticated: true,
  },
  {
    routePath: screeningRoutePaths.storyResume,
    pageToRender: <ScreeningStoryResumePage />,
    ifIsAuthenticated: true,
  },
];
